import YgrdrasilFigmaTextWithStyleOverrides from '../ygdrasil/components/FigmaTextWithStyleOverrides'

function FigmaTextWithStyleOverrides(props) {
  return <YgrdrasilFigmaTextWithStyleOverrides {...props} Component={(props) => <span {...(props as any)} />} />
}

export default FigmaTextWithStyleOverrides
